import {
  faDiagramProject,
  faPerson,
  faRecycle,
  faSparkles,
  faWineGlassCrack,
  faBox,
  faCloud,
  faLock,
  faUnlock,
  faFile,
  faPallet,
  faEnvelope as faEnvelopeLight,
  faBoxTaped,
} from "@awesome.me/kit-c1b85ff10f/icons/classic/light";
import {
  faEnvelope as faEnvelopeSolid,
  faCircleY,
  faCircleN,
  faTruckFast,
} from "@awesome.me/kit-c1b85ff10f/icons/classic/solid";
import { useAppContext } from "../AppProvider";
import timezones from "./timezones.json";

export const useTypes = () => {
  const { dictionary } = useAppContext();

  const companies = [
    {
      value: "MASTER_ORGANIZATION",
      label: `Master ${dictionary.registries.organization}`,
      color: "#ff5050",
    },
    {
      value: "ORGANIZATION",
      label: dictionary.registries.organization,
      color: "#ffd075",
    },
    {
      value: "AFILIATE",
      label: dictionary.registries.affiliate,
      color: "#dd9ef9",
    },
    {
      value: "CUSTOMER",
      label: dictionary.registries.customer,
      color: "#75ceff",
    },
    {
      value: "MASTER_ORGANIZATION",
      label: `Master ${dictionary.registries.organization}`,
      color: "#de1600",
    },
  ];

  const currencies = [
    { value: "EUR", label: "€" },
    // { value: "GBR", label: "£" },
    { value: "USD", label: "$" },
  ];

  const currencies2 = [
    { value: "EUR", label: dictionary.currencies.eur },
    // { value: "GBR", label: dictionary.currencies.gbr },
    { value: "USD", label: dictionary.currencies.usd },
  ];

  const shipments = [
    {
      value: "EXPRESS",
      label: dictionary.contracts.express,
      color: "#2979FF",
      icon: faTruckFast,
    },
    {
      value: "EXPRESS_RETURN",
      label: dictionary.contracts.express_return,
      color: "#FFA000",
      icon: faTruckFast,
    },
    {
      value: "POSTAL",
      label: dictionary.contracts.postal,
      color: "#8D6E63",
      icon: faEnvelopeSolid,
    },
  ];

  const parcels = [
    {
      value: "ENV",
      label: dictionary.parcels.envelope,
      icon: faEnvelopeLight,
    },
    {
      value: "DOC",
      label: dictionary.parcels.document,
      icon: faFile,
    },
    {
      value: "PKG",
      label: dictionary.parcels.package,
      icon: faBoxTaped,
    },
    {
      value: "PAL",
      label: dictionary.parcels.pallet,
      icon: faPallet,
    },
  ];

  const orderStatus = [
    { value: "DRAFT", label: dictionary.status.draft, color: "#C8C6C6" },
    {
      value: "CONFIRMED",
      label: dictionary.status.confirmed_sm,
      color: "#A5A3A3",
    },
    {
      value: "RECEIVED",
      label: `${dictionary.status.received_from_warehouse_sm}`,
      color: "#ff8800",
    },
    {
      value: "CANCELLED",
      label: dictionary.status.cancelled_sm,
      color: "#E51212",
    },
    {
      value: "PROCESSING",
      label: dictionary.status.processing,
      color: "#70AFE2",
    },
    {
      value: "SHIPPED",
      label: dictionary.status.shipped_sm,
      color: "#5DBB85",
    },
    {
      value: "RET_SENDER",
      label: dictionary.status.return_sender,
      color: "#585a60",
    },
    {
      value: "RET_DELIVERED",
      label: dictionary.status.return_delivered,
      color: "#B489C9",
    },
    { value: "ERROR", label: dictionary.status.rejected_sm, color: "#E51212" },
  ];

  const orderTypes = [
    {
      value: "FORWARD",
      label: dictionary.contracts.forward,
    },
    {
      value: "RETURN",
      label: `${dictionary.contracts.express_return}`,
    },
  ];

  const shipmentStatus = [
    {
      value: "DRAFT",
      label: dictionary.status.draft,
      color: "#C8C6C6",
    },
    {
      value: "BOOKED",
      label: dictionary.status.booked_sm,
      color: "#A5A3A3",
    },
    {
      value: "DELETED",
      label: dictionary.status.cancelled_sm,
      color: "#E51212",
    },
    {
      value: "CONFIRMED",
      label: dictionary.status.confirmed_sm,
      color: "#7E7D7D",
    },
    {
      value: "AVAILABLE",
      label: dictionary.status.available_for_collection,
      color: "#EF7414",
    },
    {
      value: "IN_TRANSIT",
      label: dictionary.status.in_transit,
      color: "#70AFE2",
    },
    {
      value: "OUT_OF_DLV",
      label: dictionary.status.out_of_delivery,
      color: "#EFA448",
    },
    {
      value: "EXCEPTION",
      label: dictionary.status.delivery_exception,
      color: "#CB6656",
    },
    {
      value: "FAILED_DLV",
      label: dictionary.status.failed_delivery,
      color: "#B489C9",
    },
    {
      value: "DELIVERED",
      label: dictionary.status.delivered_sm,
      color: "#5DBB85",
    },
    {
      value: "INFO_RCVD",
      label: dictionary.status.infos_received,
      color: "#294978",
    },
    {
      value: "RET_SENDER",
      label: dictionary.status.return_sender,
      color: "#585a60",
    },
    {
      value: "LOST",
      label: dictionary.status.lost_sm,
      color: "#585a60",
    },
    {
      value: "TKN_DLV",
      label: dictionary.status.taking_charge,
      color: "#7E7D7D",
      hidden: true,
    },
    {
      value: "STOCK_RELEASE",
      label: dictionary.shipments.stock_release,
      color: "#000000",
      hidden: true,
    },
    {
      value: "ABANDONED",
      label: `${dictionary.status.abbandoned_sm}/${dictionary.status.destroyed_sm}`,
      color: "#585a60",
    },
  ];

  const confirmationOptions = [
    { value: "true", label: dictionary.words.yes, isBool: false },
    { value: "false", label: dictionary.words.no, isBool: false },
  ];

  const nullableOptions = [
    { value: "NULL", label: dictionary.words.yes },
    { value: "NOT_NULL", label: dictionary.words.no },
  ];

  const booleanOptions = [
    {
      value: "TRUE",
      label: dictionary.words.yes,
      color: "#5DBB85",
      icon: faCircleY,
    },
    {
      value: "FALSE",
      label: dictionary.words.no,
      color: "#ff0000",
      icon: faCircleN,
    },
  ];

  const contractTypes = [
    {
      value: "ACTIVE",
      label: dictionary.words.active,
      color: "#8e70c1",
    },
    {
      value: "PASSIVE",
      label: dictionary.words.passive,
      color: "#ffd648",
    },
  ];

  const confirmationBoolOptions = [
    { value: "true", label: dictionary.words.yes, isBool: true },
    { value: "false", label: dictionary.words.no, isBool: true },
  ];

  const locationLevels = [
    {
      value: "AddressType",
      label: dictionary.locations.address,
      color: "#e6194B",
    },
    {
      value: "StreetType",
      label: dictionary.locations.street,
      color: "#f58231",
    },
    {
      value: "IntersectionType",
      label: dictionary.locations.intersection,
      color: "#ffe119",
    },
    {
      value: "PointOfInterestType",
      label: dictionary.locations.point_of_interest,
      color: "#bfef45",
    },
    {
      value: "CountryType",
      label: dictionary.locations.country,
      color: "#3cb44b",
    },
    {
      value: "RegionType",
      label: dictionary.locations.region,
      color: "#42d4f4",
    },
    {
      value: "SubRegionType",
      label: dictionary.locations.province,
      color: "#4363d8",
    },
    {
      value: "MunicipalityType",
      label: dictionary.locations.city,
      color: "#911eb4",
    },
    {
      value: "NeighborhoodType",
      label: dictionary.locations.district,
      color: "#f032e6",
    },
    {
      value: "PostalCodeType",
      label: dictionary.locations.postal_code,
      color: "#000075",
    },
  ];

  const goods = [
    { value: "NEW", label: dictionary.words.new_sm, icon: faSparkles },
    { value: "USED", label: dictionary.words.used_sm, icon: faRecycle },
    {
      value: "DAMAGED",
      label: dictionary.words.damaged,
      icon: faWineGlassCrack,
    },
  ];

  const ownership = [
    {
      value: "inherited",
      label: dictionary.words.inherited,
      icon: faDiagramProject,
    },
    { value: "own", label: dictionary.words.own_sm, icon: faPerson },
  ];

  const products = [
    {
      value: "PHYSICAL",
      label: dictionary.products.physical_good,
      icon: faBox,
      color: "#7E7D7D",
    },
    {
      value: "DIGITAL",
      label: dictionary.products.digital_good,
      icon: faCloud,
      color: "#70AFE2",
    },
  ];

  const domains = [
    {
      value: "PRIVATE",
      label: dictionary.words.private,
      icon: faLock,
    },
    {
      value: "PUBLIC",
      label: dictionary.words.public,
      icon: faUnlock,
    },
  ];

  const languages = [
    {
      value: "it",
      label: "Italiano",
      logoUrl: "https://www.worldometers.info//img/flags/small/tn_it-flag.gif",
    },
    {
      value: "en",
      label: "English",
      logoUrl: "https://www.worldometers.info//img/flags/small/tn_uk-flag.gif",
    },
    {
      value: "fr",
      label: "Français",
      logoUrl: "https://www.worldometers.info//img/flags/small/tn_fr-flag.gif",
    },
  ];

  const triggers = [
    {
      value: "ORDER_PROCESSED",
      label: dictionary.orders.order_processed,
      color: "#70AFE2",
    },
    {
      value: "SHIPMENT_CREATED",
      label: dictionary.shipments.shipment_created,
      color: "#7E7D7D",
    },
    {
      value: "SHIPMENT_DELIVERY",
      label: dictionary.shipments.shipment_delivery,
      color: "#EFA448",
    },
    {
      value: "SHIPMENT_DELIVERED",
      label: dictionary.shipments.shipment_delivered,
      color: "#5DBB85",
    },
  ];

  const emailEvents = [
    {
      value: "CREATED",
      label: dictionary.status.created_sm,
    },
    {
      value: "SENT",
      label: dictionary.status.sent_sm,
    },
    {
      value: "OPENED",
      label: dictionary.status.opened_sm,
    },
    {
      value: "BOUNCED",
      label: dictionary.status.rejected_sm,
    },
    {
      value: "COMPLAINT",
      label: dictionary.status.complaint_sm,
    },
    {
      value: "CLICKED",
      label: dictionary.status.clicked_sm,
    },
    {
      value: "RECEIVED",
      label: dictionary.status.received_sm,
    },
  ];

  const barcodeMovements = [
    ...orderStatus,
    ...shipmentStatus,
    {
      value: "MOVEMENT",
      label: dictionary.words.movement,
      color: "#ffd075",
    },
  ].filter(
    (item, index, self) =>
      index === self.findIndex((t) => t.value === item.value)
  );

  const suppliers = [
    {
      value: "COMPANY",
      label: dictionary.registries.company,
      color: "#70AFE2",
    },
    {
      value: "INTEGRATION",
      label: dictionary.integrations.integration,
      color: "#7E7D7D",
    },
  ];

  const purchases = [
    {
      value: "SHIPMENT",
      label: dictionary.shipments.shipment,
    },
    {
      value: "PLAN_PURCHASE",
      label: dictionary.integrations.integration,
      color: "#7E7D7D",
    },
  ];

  const customData = [
    { value: "COMMERCIAL_SAMPLE", label: "Commercial sample" },
    { value: "COMMERCIAL_PARCEL", label: "Commercial parcel" },
    { value: "DOCUMENT", label: "Document" },
    { value: "GIFT", label: "Gift" },
    { value: "OTHER", label: "Other" },
    { value: "RETURN_OF_GOODS", label: "Return of goods" },
  ];

  return {
    companies,
    currencies,
    currencies2,
    shipments,
    parcels,
    orderStatus,
    orderTypes,
    shipmentStatus,
    confirmationOptions,
    confirmationBoolOptions,
    nullableOptions,
    booleanOptions,
    locationLevels,
    ownership,
    goods,
    products,
    domains,
    languages,
    triggers,
    emailEvents,
    barcodeMovements,
    timezones,
    suppliers,
    purchases,
    customData,
    contractTypes,
  };
};
